<div class="cr-logo"></div> <ui-view class="cr-content"></ui-view> 